import { Button, Col, Input, InputNumber, message, Radio, Row, Space } from "antd";
import { useContext, useState } from "react";
import { FiArrowRight } from "react-icons/fi";
import { AuthContext } from "../../Contexts/AuthContext";
import { CartContext } from "../../Contexts/CartContext";
import CartOrderSummary from "../CartOrderSummary/CartOrderSummary";
import { FloatingCartButton } from "../CartScreen/CartScreen";
import styles from "./PaymentMethod.module.scss";
import hermes_logo from "../ShippingAddressScreen/images/hermes_logo.svg";
import dpd_logo from "../ShippingAddressScreen/images/dpd_logo.svg";
import ups_logo from "../ShippingAddressScreen/images/ups_logo.svg";
import info_icon from "./images/info.svg";

const PaymentMethodScreen = ({
    step,
    setStep,
}) => {
    const cartContext = useContext(CartContext);
    const { paymentMethod, setPaymentMethod } = useContext(CartContext);
    const { user, isAuthenticated } = useContext(AuthContext);



    const [selectedRP, setSelectedRP] = useState(null);

    const redeemRewardPoints = () => {
        if (!selectedRP) {
            message.error('Please enter number of reward points you want to redeem!')
            return;
        }

        if (selectedRP > user.reward_points) {
            message.error(`You have maximum ${user.reward_points} to redeem!`);
            return;
        }

        let dAmount = selectedRP / 100

        message.success(`You have redeemed ${dAmount}€ discount using your reward points!`);

        cartContext.setRPDiscount(dAmount);
    }

    return (
        <div className={"container"}>
            {/*<br />*/}

            <Row gutter={[30]}>
                <Col lg={18} xs={24}>
                    {/*coupon code*/}
                    {/*<div className={styles.calc}>*/}
                    {/*    <span>*/}
                    {/*        Total Price{" "}*/}
                    {/*        <span*/}
                    {/*            style={{*/}
                    {/*                fontSize: "1.2rem",*/}
                    {/*                color: "var(--color-grey)",*/}
                    {/*            }}*/}
                    {/*        >*/}
                    {/*            (incl. VAT)*/}
                    {/*        </span>*/}
                    {/*    </span>*/}
                    {/*    <em>*/}
                    {/*        {parseFloat(*/}
                    {/*            cartContext.calculateOrderSubTotal() +*/}
                    {/*                cartContext.deliveryCharge +*/}
                    {/*                cartContext.calculateVat() -*/}
                    {/*                cartContext.rpDiscount*/}
                    {/*        ).toFixed(2)}{" "}*/}
                    {/*        €{" "}*/}
                    {/*    </em>*/}
                    {/*</div>*/}
                    {/*<Input.Group compact>*/}
                    {/*    <Input*/}
                    {/*        style={{*/}
                    {/*            width:*/}
                    {/*                window.innerWidth > 577*/}
                    {/*                    ? "calc(100% - 150px)"*/}
                    {/*                    : "calc(100vw - 150px)",*/}
                    {/*            height: "40px",*/}
                    {/*        }}*/}
                    {/*        placeholder={"Enter your coupon code"}*/}
                    {/*    />*/}
                    {/*    <Button*/}
                    {/*        style={{ width: "120px", height: "40px" }}*/}
                    {/*        type="primary"*/}
                    {/*    >*/}
                    {/*        Redeem*/}
                    {/*    </Button>*/}
                    {/*</Input.Group>*/}

                    {/*<br />*/}
                    {/*family card points*/}
                    {isAuthenticated && (
                        <>
                            {/*<div className={styles.calc}>*/}
                            {/*    <span>Desi Family Card</span>*/}
                            {/*    <div*/}
                            {/*        style={{*/}
                            {/*            display: "flex",*/}
                            {/*            alignItems: "center",*/}
                            {/*            gap: "5px",*/}
                            {/*        }}*/}
                            {/*    >*/}
                            {/*        <em>*/}
                            {/*            {parseInt(user.reward_points)} Points{" "}*/}
                            {/*        </em>*/}
                            {/*        <img src="/icon/points-icon.svg" alt="" />*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            {/*<Input.Group compact>*/}
                            {/*    <Input*/}
                            {/*        onChange={e=>setSelectedRP(e.target.value)}*/}
                            {/*        style={{*/}
                            {/*            width:*/}
                            {/*                window.innerWidth > 577*/}
                            {/*                    ? "calc(100% - 150px)"*/}
                            {/*                    : "calc(100vw - 150px)",*/}
                            {/*            height: "40px",*/}
                            {/*        }}*/}
                            {/*        placeholder={`${parseInt(*/}
                            {/*            user.reward_points*/}
                            {/*        )} Points`}*/}

                            {/*    />*/}
                            {/*    <Button*/}
                            {/*        style={{ width: "120px", height: "40px" }}*/}
                            {/*        type="primary"*/}
                            {/*        onClick={redeemRewardPoints}*/}
                            {/*    >*/}
                            {/*        Redeem*/}
                            {/*    </Button>*/}
                            {/*</Input.Group>*/}
                            {/*<p*/}
                            {/*    style={{*/}
                            {/*        marginTop: "5px",*/}
                            {/*        color: "var(--color-grey)",*/}
                            {/*        fontSize: "1.4rem",*/}
                            {/*    }}*/}
                            {/*>*/}
                            {/*    Turn your points into real cash today!*/}
                            {/*</p>*/}
                            {/*<br />*/}
                        </>
                    )}

                    {/*Payment Method Select*/}
                    <br className={'mb_only'} />
                    <div className={styles.calc}>
                        <span className={'text-primary fs-3 fw-bold'}>Select Payment Method</span>
                    </div>

                    <div className={styles.payment_methods} style={{ maxWidth: '750px' }}>
                        <Row gutter={[15, 15]}>
                            <Col span={24}>
                                <div
                                    className={'custom_radio_box d-flex align-items-center'}
                                    onClick={() => setPaymentMethod('card')}
                                >
                                    <div>
                                        <Radio checked={paymentMethod === 'card'} />
                                        <b>Credit  / Debit Card</b>
                                    </div>
                                    <img style={{ marginLeft: 'auto' }} src={window.innerWidth > 576 ? "https://desi-fresh.b-cdn.net/misc/dekstop-card-pm.svg" : "/icon/checkout/pm_1.svg"} alt="" />
                                </div>
                            </Col>
                            <Col span={24}>
                                <div
                                    className={'custom_radio_box d-flex align-items-center'}
                                    onClick={() => setPaymentMethod('sofort')}
                                >
                                    <div>
                                        <Radio checked={paymentMethod === 'sofort'} />
                                        <b>Sofort</b>
                                    </div>
                                    <img style={{ marginLeft: 'auto' }} src={'/icon/checkout/pm_5.svg'} alt="" />
                                </div>
                            </Col>
                            {/* <Col span={24}>
                                    <div
                                        className={'custom_radio_box d-flex align-items-center'}
                                        onClick={()=>setPaymentMethod('giropay')}
                                    >
                                        <div>
                                            <Radio checked={paymentMethod === 'giropay'}/>
                                            <b>GiroPay</b>
                                        </div>
                                        <img style={{marginLeft: 'auto'}} src={'https://desi-fresh.b-cdn.net/components_static/Giropay.svg'} alt=""/>
                                    </div>
                                </Col> */}
                            {/* <Col span={24}>
                                    <div
                                        className={'custom_radio_box d-flex align-items-center'}
                                        onClick={()=>setPaymentMethod('paypal')}
                                    >
                                        <div>
                                            <Radio checked={paymentMethod === 'paypal'}/>
                                            <b>Paypal</b>
                                        </div>
                                        <img style={{marginLeft: 'auto'}} src={'/icon/checkout/pm_3.svg'} alt=""/>
                                    </div>
                                </Col> */}
                        </Row>
                    </div>


                    {/*info section*/}

                    <div className={styles.please_note + " mb_only"}>
                        <img src={info_icon} alt="" />
                        <div>
                            <span>Please Note:</span>
                            <p>Fresh Fruits and Vegetables, refrigerated and frozen products are non refundable.</p>
                        </div>
                    </div>

                    {/* <div className={styles.secure_payment + " mb_only"}>
                        <img src="/icon/checkout/lock.svg" alt="" />
                        <span>Secure Payment Guaranteed</span>
                    </div>
                    <div className={styles.small_info}>
                        <img src="/icon/family-card.png" alt="" />
                        <span>Earn points fast! 1 points per 2€ spent</span>
                        <img
                            style={{ width: "20px" }}
                            src="/icon/points-icon.svg"
                            alt=""
                        />
                    </div>
                    <div className={styles.small_info + " mb_only"}>
                        <img src="/icon/auth/si_4.svg" alt="" />
                        <span>
                            Your purchase helps underprivileged children.
                        </span>
                    </div>
                    <div className={styles.small_info + " mb_only"}>
                        <img src="/icon/checkout/pm_free.svg" alt="" />
                        <span>Get free shipping at 49.99€</span>
                    </div> */}

                    {/*tip section*/}

                </Col>
                <Col xs={0} lg={6}>
                    <CartOrderSummary
                        cartContext={cartContext}
                        step={step}
                        setStep={setStep}
                    />
                </Col>
            </Row>

            <FloatingCartButton setStep={setStep} step={step} />
        </div>
    );
};

export default PaymentMethodScreen;
